import { useEffect, useRef, type ReactNode } from 'react';
import { useQueryClient } from '@tanstack/react-query';
import { initializeAppAuth, useAppAuthState } from '../lib/app-auth';

export function AuthProvider({ children }: { children: ReactNode }) {
  const queryClient = useQueryClient();
  const authState = useAppAuthState();
  const userId = authState.user?.id ?? null;
  const previousUserIdRef = useRef<string | null>(null);

  useEffect(() => {
    void initializeAppAuth();
  }, []);

  // A user switch drops the previous account's cached queries. Finishing
  // onboarding is deliberately NOT observed here any more: the chat welcome
  // upsell (and the tour it chains into) left the completion path, which now
  // lands on the user's CV. The welcome is still requested where it belongs
  // elsewhere (the password bootstrap for migrated accounts).
  useEffect(() => {
    const previousUserId = previousUserIdRef.current;
    if (previousUserId && previousUserId !== userId) {
      queryClient.clear();
    }
    previousUserIdRef.current = userId;
  }, [queryClient, userId]);

  return <>{children}</>;
}
